function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4705 114.189L0 234.821H106.75L187.999 112.997L108.986 0H0.628087L80.4705 114.189Z",
  fill: "url(#paint0_linear_545_340)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M108.986 0H0.628124L187.999 112.997L108.986 0Z",
  fill: "#FAAF40"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_545_340",
  x1: -67.532,
  y1: 355.477,
  x2: 143.457,
  y2: -26.9437,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F05A28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAAF40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_545_340",
  x1: 8366.74,
  y1: -4105.18,
  x2: 7666.97,
  y2: 8050.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F05A28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAAF40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_545_340",
  x1: 10355,
  y1: 15800.2,
  x2: 8601.87,
  y2: 5670.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F05A28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAAF40"
})));

var SvgCmdIconPositive = function SvgCmdIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 235,
    viewBox: "0 0 188 235",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref3), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M0.628124 0L187.999 112.997L184.557 108.076L0.628124 0Z",
    fill: "url(#paint1_linear_545_340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M188 112.996L0.000857089 234.819H106.751L188 112.996Z",
    fill: "url(#paint2_linear_545_340)"
  }), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCmdIconPositive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cmd_icon_positive.296304bb.svg";
export { ForwardRef as ReactComponent };